import { List, Text } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const ManagementAccountDocumentUpload = ({
  duration,
  error,
}: {
  duration?: number;
  error?: string;
}): UIElement => {
  const intl = useIntl();
  const requiredDuration = duration ?? 12;
  return (
    <DocumentUpload
      documentType={UploadDocumentType.MANAGEMENT_ACCOUNTS}
      supportedFileExtensions={[".xlsx"]}
      fileSizeLimitMB={50}
      error={error}
      description={
        <List type="bullet">
          {intl.formatMessage(MESSAGES.managementAccountsDescription, {
            li: (chunks: ReactNode[]) => <List.Item>{chunks}</List.Item>,
            strong: (chunks: ReactNode[]) => (
              <Text element="span" fontWeight="semiBold">
                {chunks}
              </Text>
            ),
            em: (chunks: ReactNode[]) => (
              <Text element="span" fontStyle="italic">
                {chunks}
              </Text>
            ),
            duration: requiredDuration,
          })}
        </List>
      }
    />
  );
};
